var map = {
	"./goods/advanced_weapons.png": "58d7",
	"./goods/alpaca_wool.png": "fdee",
	"./goods/beef.png": "02a3",
	"./goods/beer.png": "43c4",
	"./goods/bowler_hat.png": "1891",
	"./goods/brass.png": "2159",
	"./goods/bread.png": "3ad6",
	"./goods/bricks.png": "1497",
	"./goods/canned_food.png": "f6f5",
	"./goods/caoutchouc.png": "efc2",
	"./goods/carbon_filament.png": "e1f8",
	"./goods/cement.png": "5c31",
	"./goods/champagne.png": "c989",
	"./goods/charcoal_kiln.png": "5843",
	"./goods/chassis.png": "0dac",
	"./goods/chocolate.png": "3ae5",
	"./goods/cigars.png": "fe22",
	"./goods/clay.png": "d3b5",
	"./goods/coal.png": "ae3c",
	"./goods/cocoa.png": "6611",
	"./goods/coffee.png": "d2e7",
	"./goods/coffee_beans.png": "5b1f",
	"./goods/copper.png": "8150",
	"./goods/corn.png": "c82d",
	"./goods/cotton.png": "ae74",
	"./goods/cotton_fabric.png": "315e",
	"./goods/dynamite.png": "2680",
	"./goods/felt.png": "b14e",
	"./goods/fish.png": "d12c",
	"./goods/fish_oil.png": "75bb",
	"./goods/flour.png": "183c",
	"./goods/fried_plantains.png": "b0aa",
	"./goods/fur_coats.png": "8b2b",
	"./goods/furs.png": "bc32",
	"./goods/glass.png": "5846",
	"./goods/glasses.png": "d2fe",
	"./goods/gold.png": "ed3f",
	"./goods/gold_ore.png": "6a50",
	"./goods/goulash.png": "fe80",
	"./goods/grain.png": "337a",
	"./goods/gramophone.png": "50f4",
	"./goods/grapes.png": "1c1e",
	"./goods/high_wheeler.png": "dfae",
	"./goods/hops.png": "8e23",
	"./goods/iron.png": "361c",
	"./goods/jewelry.png": "5d13",
	"./goods/light_bulb.png": "b310",
	"./goods/malt.png": "f4f0",
	"./goods/oil.png": "b018",
	"./goods/pearls.png": "04c8",
	"./goods/pepper.png": "468c",
	"./goods/pigs.png": "45b4",
	"./goods/plantains.png": "e2db",
	"./goods/pocket_watch.png": "cf62",
	"./goods/poncho.png": "a053",
	"./goods/potato.png": "4333",
	"./goods/quartz_sand.png": "1375",
	"./goods/reinforced_concrete.png": "d14d",
	"./goods/rum.png": "98f6",
	"./goods/sails.png": "745d",
	"./goods/saltpeter.png": "9a10",
	"./goods/sausages.png": "6b22",
	"./goods/schnapps.png": "c7a1",
	"./goods/sewing_machine.png": "b54f",
	"./goods/soap.png": "5d20",
	"./goods/steam_carriage.png": "aa34",
	"./goods/steam_motor.png": "4d18",
	"./goods/steel.png": "5709",
	"./goods/steel_beams.png": "f892",
	"./goods/sugar.png": "f938",
	"./goods/sugar_cane.png": "4d57",
	"./goods/tallow.png": "f826",
	"./goods/timber.png": "edeb",
	"./goods/tobacco.png": "8640",
	"./goods/tortilla.png": "122e",
	"./goods/weapons.png": "4e05",
	"./goods/windows.png": "03fa",
	"./goods/wood.png": "41ea",
	"./goods/wood_veneers.png": "64d6",
	"./goods/wool.png": "7af7",
	"./goods/work_clothes.png": "c940",
	"./goods/zinc.png": "6b6c",
	"./population/artisan.png": "1603",
	"./population/engineer.png": "f1d8",
	"./population/farmer.png": "5f4d",
	"./population/investor.png": "5b19",
	"./population/jornalero.png": "219f",
	"./population/obrero.png": "4520",
	"./population/worker.png": "78c9",
	"./resources/attractiveness.png": "a5d9",
	"./resources/balance.png": "58ef",
	"./resources/credits.png": "876f",
	"./resources/happiness_negative.png": "43ca",
	"./resources/happiness_neutral.png": "bb10",
	"./resources/happiness_positive.png": "932b",
	"./resources/influence.png": "4245",
	"./resources/population.png": "c6bc",
	"./resources/workforce_artisan.png": "ed6c",
	"./resources/workforce_engineer.png": "6c4a",
	"./resources/workforce_farmer.png": "cea9",
	"./resources/workforce_investor.png": "bd02",
	"./resources/workforce_jornalero.png": "24af",
	"./resources/workforce_obrero.png": "9d4b",
	"./resources/workforce_worker.png": "0a15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";